import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

// TODO 18368: Add new jsons and update import for locale
import CONTENT from '../../static-content/case-studies.json';
import COMMON from '../../static-content/common.json';
import getLocalCaseStudiesMain from "../../templates/case-studies";

const propTypes = {
  data: PropTypes.shape({
    featuredCaseStudies: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    allContentfulCaseStudy: PropTypes.shape({
      nodes: PropTypes.arrayOf(PropTypes.object)
    }).isRequired,
    allContentfulService: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          categoryName: PropTypes.string
        })
      )
    }).isRequired,
    allContentfulIndustry: PropTypes.shape({
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string
        })
      )
    }).isRequired
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string
  }).isRequired
};


/**
 * Component that renders the list of all case studies
 *
 * @component
 * @param {object} props
 */
const CaseStudiesMain = props => {
  const { location, data } = props;
  const seoSlug = 'en-us/case-studies';
  return getLocalCaseStudiesMain(location, data, CONTENT, COMMON, seoSlug, process.env.CONTENTFUL_US_SPACE_ID);
};

CaseStudiesMain.propTypes = propTypes;

export default CaseStudiesMain;

// TODO 18369: Update queries for locale
export const pageQuery = graphql`
  query CaseStudiesBySpaceId($globalSpaceId: String!, $usSpaceId: String!) {
    featuredCaseStudies: allContentfulFeaturedCaseStudies(filter: {spaceId: {eq: $usSpaceId}}, limit: 6) {
      nodes {
        featuredCaseStudies {
          ...NoContentCaseStudy
        }
        globalFeaturedCaseStudies {
          sys {
            urn
          }
        }
      }
    }
    allContentfulCaseStudy(filter: {spaceId: {in: [$usSpaceId, $globalSpaceId]}}, sort: {spaceId: DESC}) {
      nodes {
        ...NoContentCaseStudy
      }
    }
    allContentfulServiceLine(filter: {spaceId: {in: [$usSpaceId, $globalSpaceId]}}) {
      nodes {
        title
        contentful_id
      }
    }
    allContentfulIndustry(filter: {spaceId: {in: [$usSpaceId, $globalSpaceId]}}) {
      nodes {
        title
        slug
        localizationSlug
        spaceId
        contentful_id
      }
    }
  }
`;
